import React from 'react'
import Tools from '../../../components/Tools/Tools';
import EditInvoice from '../../../components/AddVoucher/EditInvoice';

const UpdateInvoice = () => {
  return (
    <div>
        {/* <Tools/> */}
        <div className='scheme p-2'>
          <EditInvoice/>
        </div>
    </div>
  )
}

export default UpdateInvoice
